import { render, staticRenderFns } from "./clientLayout.vue?vue&type=template&id=861130d6&scoped=true"
import script from "./clientLayout.vue?vue&type=script&lang=js"
export * from "./clientLayout.vue?vue&type=script&lang=js"
import style0 from "./clientLayout.vue?vue&type=style&index=0&id=861130d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861130d6",
  null
  
)

export default component.exports